export const keycloakConfig = {
  url: 'https://login.dev.digital.m-3.com',
  realm: 'master',
  clientId: 'm3-waf-dashboard'
};